import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FiArrowRight } from "react-icons/fi";
import FlowField from "../components/forms/FlowField";
import "./styles/flow-form.css";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/loader/Loader";

function SectorActivityName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);

  // Validation schema
  const validationSchema = Yup.object().shape({
    sectorActivity: Yup.string().required("Le secteur d'activité est requis"),
  });

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        sectorActivity: values.sectorActivity.trim(),
        customSector: values.sectorActivity.trim(),
      }),
    );

    if (cart.from === "creation") {
      navigate("/manager-type");
    } else {
      navigate("/have-business-name");
    }
  };

  return (
    <div className="flow-form-page">
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          Quel est votre <span>secteur d'activité</span> ?
        </h1>
        <p className="flow-form-lead">
          Décrivez en quelques mots l'activité principale de votre{" "}
          {cart?.businessType}.
        </p>
      </header>

      <Formik
        initialValues={{
          sectorActivity: cart.customSector || "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flow-form" noValidate>
          <FlowField
            name="sectorActivity"
            label="Secteur d'activité"
            placeholder="Ex. : Transport de marchandises"
          />

          <div className="flow-actions">
            <button type="submit" className="flow-submit" disabled={submitting}>
              Continuer <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default SectorActivityName;
